import React, { FunctionComponent, useEffect, useState } from 'react'
import { RootStateOrAny, useDispatch, useSelector } from 'react-redux'
import { Link, useHistory } from 'react-router-dom'
import logo from 'Shared/img/logo.png'
import { getSpotifyTrack as onGetSpotifyTrack } from 'Redux/actions/trackActions'
import { getFreeSpotifyAccessToken } from 'Redux/actions/spotifyTokenActions'
import {
  createFirstCampaignStartEvent,
  locationEvent,
  pageInfo,
  pageViewEvent,
  campaignSentToReviewEvent,
  viewSignUpPopUpEvent,
  firstCampaignDetailsEvent,
} from 'Helpers/tagManager'
import { getAmountOfCampaigns } from 'Redux/selectors/campaigns'
import { getUserId } from 'Redux/selectors/auth'
import { CreateCampaignLayout } from 'Containers/CreateCampaignWithoutSignup/components/CreateCampaignLayout'
import { Track, CampaignPlatformTypeEnum } from '../../Types'
import { Logo, TopbarComponent, CreateCampaignBlock } from './styles'

const CreateCampaignForm: FunctionComponent = () => {
  const dispatch = useDispatch()
  const history = useHistory()
  const userId = useSelector(getUserId)
  const amountOfCampaigns = useSelector(getAmountOfCampaigns)
  const campaignNumber = amountOfCampaigns + 1

  const spotifyTrack: Track = useSelector(
    (state: RootStateOrAny) => state.spotifyTrack.track
  )

  const spotifyTracks: Array<Track> = useSelector(
    (state: RootStateOrAny) => state.spotifyTracks.tracks
  )

  const accessToken: string = useSelector(
    (state: RootStateOrAny) => state.spotifyToken.accessToken
  )

  const [isChangedTrack, setIsChangedTrack] = useState(true)

  const [modalFormRegister, setModalFormRegister] = useState(false)

  const toggleFormRegister = () => {
    setModalFormRegister(!modalFormRegister)
    history.push(`?details=${spotifyTrack.name}`)
  }

  const [serverOverloadedModal, setServerOverloadedModal] = useState(false)

  // for future
  const [loading, setIsLoading] = useState(true)

  useEffect(() => {
    pageViewEvent(null, pageInfo.createCampaignWithoutSignUp)
    locationEvent()
    createFirstCampaignStartEvent()

    dispatch(
      // @ts-ignore
      getFreeSpotifyAccessToken((error: string) => {
        setIsLoading(false)
        if (error) {
          setServerOverloadedModal(true)
        }
      })
    )
  }, [])

  // TODO unused component?
  useEffect(() => {
    if (spotifyTrack) {
      // @ts-ignore
      dispatch(onGetSpotifyTrack(spotifyTrack))
    } else {
      // @ts-ignore
      dispatch(onGetSpotifyTrack(JSON.parse(localStorage.getItem('track'))))
    }
  }, [spotifyTrack])

  const [isCheckedSpotify, setCheckedSpotify] = useState(true)
  const [isCheckedTikTok, setCheckedTikTok] = useState(false)

  const handleSubmit = () => {
    // @ts-ignore
    const user = JSON.parse(localStorage.getItem('user'))
    localStorage.setItem('user', JSON.stringify(user))
    campaignSentToReviewEvent(
      true,
      CampaignPlatformTypeEnum.SPOTIFY,
      campaignNumber || 1
    )

    toggleFormRegister()
    spotifyTrack && !userId && firstCampaignDetailsEvent(spotifyTrack)
    viewSignUpPopUpEvent(CampaignPlatformTypeEnum.SPOTIFY)
  }

  return (
    <CreateCampaignLayout
      history={history}
      isChangedTrack={isChangedTrack}
      handleSubmit={handleSubmit}
      isCheckedSpotify={isCheckedSpotify}
      setCheckedSpotify={setCheckedSpotify}
      accessToken={accessToken}
      isCheckedTikTok={isCheckedTikTok}
      setCheckedTiktok={setCheckedTikTok}
      setIsChangedTrack={setIsChangedTrack}
      spotifyTrack={spotifyTrack}
      spotifyTracks={spotifyTracks}
      serverOverloadedModal={serverOverloadedModal}
      setServerOverloadedModal={setServerOverloadedModal}
      modalFormRegister={modalFormRegister}
      setModalFormRegister={setModalFormRegister}
    >
      <TopbarComponent>
        <CreateCampaignBlock>
          <Logo>
            <Link to="/">
              <img alt="logo" src={logo} />
            </Link>
          </Logo>
        </CreateCampaignBlock>
      </TopbarComponent>
    </CreateCampaignLayout>
  )
}

export default CreateCampaignForm
